import React, { useEffect, useRef, useState } from 'react'
import {
    PiCaretDownFill,
    PiCaretUpFill,
    PiCheckCircleFill,
    PiWarningFill,
} from "react-icons/pi";
import { addMandateDebitApi, batchUploadFileAllNewMandates, cancelBulkDebitApi, debittingCountApi, faAppReport, getAllNewMandates, getAllNewMandatesTransactions, getAllWorkflowMandates, mailReportApi, mailworkFlowReportApi, searchAllNewMandates, singleDebitApi, smsworkFlowReportApi, uploadOnDemandMandateFileApi, workFlowReportApi } from '../services';
import moment from 'moment';
import { useParams } from 'react-router';
import ReactPaginate from 'react-paginate';
import LoadingModal from '../components/modals/LoadingModal';
import { HiOutlineDotsVertical } from 'react-icons/hi';
import { ModalSingleDebit } from '../components/modals/ModalSingleDebit';
import { notify } from '../components/actions/CommonActions';
import { Button, Form, Row, Col, InputGroup, Table } from "react-bootstrap";
import { FiRefreshCcw } from 'react-icons/fi';
import { TransactionHistory } from '../components/modals/TransactionHistory';
import { AllNewTransactionModal } from '../components/modals/AllNewmandateTransactionModal';
import { AddDebitMandateModal } from '../components/modals/AddDebitMandateModal';

const AllNewMandates = () => {
    const [allMandates, setAllMandates] = useState([])
    const [loading, setLoading] = useState(false)
    const { mandateId, workflowId } = useParams()
    const [pageCount, setPageCount] = useState(0); // For total pages
    const [currentPage, setCurrentPage] = useState(1); // Current page
    const [limit, setLimit] = useState(10)
    const [selectedDetails, setSelectedDetails] = useState(null)
    const [search, setSearch] = useState("")
    const [isLoading, setIsLoading] = useState(false);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [batchId, setBatchId] = useState(null)
    const dropdownRef = useRef(null);
    const [showSingleDebitModal, setShowSingleDebitModal] = useState(false)
    const [loadDebitting, setLoadDebitting] = useState(false)
    const [isUploadFile, setIsUploadFile] = useState(false);
    const [uploadedFile, setUploadedFile] = useState(null)
    const [history, setHistory] = useState();
    const [mandateInfo, setMandateInfo] = useState(null)
    const [resumption, setIsResumption] = useState(0);
    const [note, setNote] = useState("");
      const [showFilter, setShowFilter] = useState(false);
      const [uploadingOnDemand, setUploadingOnDemand] = useState(false)

    const [stateTransact, setStateTransact] = React.useState({
        right: false,
    });
    const anchor = "right";
    const toggleDrawerTransact = (anchor, open, details) => (event) => {
        setSelectedDetails(details)
        // console.log('transact ', anchor, open);
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }

        setStateTransact({ ...stateTransact, [anchor]: open });
    }

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenDropdownId(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const WORKFLOWSTATUS = {
        BILLER_INITIATED: 1,
        BILLER_AUTHORISED: 2,
        BILLER_REJECTED: 3,
        BILLER_APPROVED: 4,
        BANK_AUTHORIZED: 6,
        BANK_REJECTED: 7,
        BANK_APPROVED: 8,
        BANK_DISAPPROVED: 9,
    };

    function getWorkflowStatusLabel(statusCode) {
        const entry = Object.entries(WORKFLOWSTATUS).find(
            ([_, value]) => value === statusCode
        );

        if (!entry) return "Unknown Status";

        // Convert key to readable format e.g., BILLER_INITIATED => Biller Initiated
        const formatted = entry[0]
            .toLowerCase()
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');

        return formatted;
    }


    const numberFormat = (value, toFixed = 2) => {
        const num = Number(value);
        if (Number.isInteger(num)) {
            return num.toLocaleString(); // Handles integer values without decimals
        } else {
            return num
                .toFixed(toFixed) // Ensures the specified number of decimal places
                .replace(/\d(?=(\d{3})+\.)/g, "$&,"); // Adds commas for thousands
        }
    };

    const handleAllMandates = async (page, limit) => {
        const params = {
            sessionId: mandateId,
            limit: limit,
            page: page,
            workflowStatus: workflowId,
            search: search,
        }

        const searchParams = new URLSearchParams()
        // Add parameters only if they are defined and not empty
        Object.entries(params).forEach(([key, value]) => {
            if (value) {
                searchParams.append(key, value);
            }
        });

        await getAllNewMandates(searchParams)
            .then((res) => {
                //   console.log("all mandates res ", res?.data?.data);
                setAllMandates(res?.data?.data)
                setPageCount(res?.data?.totalPages)
                // setFaReport(res?.data)
            })
            .catch((err) => {
                console.log('err ', err);
            })
    }

    const toggleFilter = () => {
    setShowFilter(!showFilter);
  };

    const handleSearchAllMandates = async (page, limit) => {
        const params = {
            sessionId: mandateId,
            limit: limit,
            page: page,
            workflowStatus: workflowId,
            search: search,
        }

        const searchParams = new URLSearchParams()
        // Add parameters only if they are defined and not empty
        Object.entries(params).forEach(([key, value]) => {
            if (value) {
                searchParams.append(key, value);
            }
        });

        await searchAllNewMandates(searchParams)
            .then((res) => {
                //   console.log("all mandates res ", res?.data?.data);
                setAllMandates(res?.data?.data)
                setPageCount(res?.data?.totalPages)
                // setFaReport(res?.data)
            })
            .catch((err) => {
                console.log('err ', err);
            })
    }

    const handlePageClick = async (data) => {
        setIsLoading(true);
        let selectedPage = data.selected + 1; // react-paginate uses 0-based index, so add 1
        setCurrentPage(selectedPage); // Update current page state
        await handleAllMandates(selectedPage, limit)
        setIsLoading(false);
    };


    useEffect(() => {
        const initiate = async () => {
            setLoading(true)
            await handleAllMandates(currentPage, limit)
            setLoading(false)
        }
        initiate()
    }, [])

    const toggleDropdown = (id, mandateCode, mandate) => {
        setOpenDropdownId(id);
        setBatchId(mandateCode)
        setMandateInfo(mandate)
    };

    const handleSingleDebit = async (count, reason, mandate) => {
        const sentData = {
            mandateId: `${batchId}`,
            count: count,
            reason: reason,
        }
        // console.log("sent data ", sentData);

        setLoadDebitting(true)
        await singleDebitApi(sentData)
            .then(async (res) => {
                //   console.log("all mandates res ", res?.data?.data);
                setLoadDebitting(false)
                setIsResumption("")
                setNote("")
                notify("success", "Mandate debitted successfully.", `${res?.message}`);
                setShowSingleDebitModal(false)
                await handleTransaction(mandateInfo)
                // setFaReport(res?.data)
            })
            .catch(async (err) => {
                setLoadDebitting(false)
                setShowSingleDebitModal(false)
                await handleTransaction(mandateInfo)
                notify("danger", "OOPS", `${err?.response?.data?.message}`);
                console.log('err ', err);
            })
    }

    const handleTransaction = async (mandate) => {
        setIsLoading(true)
        await getAllNewMandatesTransactions(mandate?.contractId)
            .then(async (res) => {
                //   console.log("all transaction res ", res?.data);
                await setIsLoading(false)
                await setHistory(res)
                await toggleDrawerTransact(anchor, true, mandate)({ type: "click" });
                // setShowSingleDebitModal(false)
                // setFaReport(res?.data)
            })
            .catch((err) => {
                setIsLoading(false)
                notify("danger", "OOPS", `${err?.response?.data?.message}`);
                console.log('err ', err);
            })
    }




    const handleFileChangeNew = (e) => {
        const file = e.target.files[0];
        setUploadedFile(file)

    };

    const handleUploadFileNew = async () => {
        setIsUploadFile(true);
        // console.log("uploaded file ", uploadedFile);

        const formData = new FormData()
        formData.append('file', uploadedFile)
        await batchUploadFileAllNewMandates(formData)
            .then(async (res) => {
                console.log("res ", res);

                if (res.message) {
                    // const storedPage = sessionStorage.getItem("currentPage");
                    // const initialPage = storedPage ? parseInt(storedPage, 10) : 1;
                    notify("success", "success", `${res?.message}. Created mandates: ${res?.data?.uploaded}. Duplicates: ${res?.data?.duplicates}`);
                    setIsUploadFile(false);
                    await handleAllMandates(1, 10)
                    // toggle();
                    // refetch(initialPage);
                } else {
                    notify("danger", "OOPS", "something went wrong");
                    setIsUploadFile(false);
                }
            })
            .catch((error) => {
                notify("danger", "OOPS", error?.response?.data?.message);
                setIsUploadFile(false);
            });
    };

    const handleAddMandateDebit = () =>{
        // console.log("works");
        setShowFilter(!showFilter)
    }

      const handleSubmit = async (requestData, mode) => {
        console.log("request data: ", requestData);
        
    setUploadingOnDemand(true);
    try {
      let result;
      
      if (mode === 'input') {
        // Handle input mode - send JSON data
        result = await addMandateDebitApi(requestData);
      } else if (mode === 'upload') {
        // Handle upload mode - send FormData with file
        requestData?.mandateCodes?.shift()
        result = await addMandateDebitApi(requestData);
      }
      
      notify("success", "Success", result?.message);
      setLoading(true)
      await handleAllMandates(1, 10)
      setLoading(false)
      // Handle success (show notification, refresh data, etc.)
    } catch (error) {
      console.error('Error:', error);
      // Handle error (show error message, etc.)
    } finally {
      setUploadingOnDemand(false);
    }
  };

    return (
        <>
            {loading ? (
                <div className="typewriter-container">
                    <div class="typewriter">
                        <div class="slide">
                            <i></i>
                        </div>
                        <div class="paper"></div>
                        <div class="keyboard"></div>
                    </div>
                    <code style={{ color: "#000" }}>Getting your app ready...</code>
                </div>
            ) : (
                <div style={{ overflowX: "auto" }}>
                    {/* <Row className="mb-3">
                        <Form.Group as={Col} controlId="formGridCity">
                            <Form.Label>Upload File</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type="file"
                                    placeholder="Upload excel file."
                                    name="excelFile"
                                    onChange={handleFileChangeNew}
                                />
                                <Button
                                    variant="outline-secondary"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleUploadFileNew();
                                    }}
                                    disabled={isUploadFile}
                                >
                                    {isUploadFile ? <FiRefreshCcw className="spin" /> : "Upload"}
                                </Button>
                            </InputGroup>
                        </Form.Group>
                    </Row> */}

                    <form onSubmit={async (e) => {
                        e.preventDefault()
                        setIsLoading(true);
                        await handleSearchAllMandates(1, 10)
                        setIsLoading(false);
                    }} style={{ display: "flex", justifyContent: "flex-end", padding: "10px 0", gap: "10px" }}>
                        <input type="text" onChange={(e) => setSearch(e.target.value)} style={{ border: "1px solid black", borderRadius: "5px", padding: "5px 10px", outline: "none" }} />
                        <button type="submit" style={{ border: "none", backgroundColor: "#007dcc", color: "white", padding: "0px 10px", borderRadius: "5px" }}>Search</button>
                        <button type="button" onClick={handleAddMandateDebit} style={{ border: "none", backgroundColor: "#007dcc", color: "white", padding: "0px 10px", borderRadius: "5px" }}>Upload mandates</button>
                    </form>
                    {/* <h5 className='mt-3'>Sms Report</h5> */}
                    <table className="fl-table">
                        <thead>
                            <tr style={{ borderBottom: "0.5px solid #f1f1f1" }}>
                                {/* Table header cells */}
                                {/* Modify according to your data structure */}
                                <th width="20%">Mandate Code</th>
                                <th width="20%">Subscriber Code</th>
                                <th>Amount</th>
                                <th>Account number</th>
                                <th>Bank Name</th>
                                <th>Narration</th>
                                <th>WorkFLow Status</th>
                                <th>Created At</th>
                                <th>...</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                allMandates?.map((mandate) => (
                                    <tr
                                        className="tr"
                                        key={mandate.id}
                                    >
                                        <td className="gray-td">{mandate?.mandateCode}</td>
                                        <td className="gray-td">{mandate?.contractId}</td>
                                        <td className="gray-td">{Number(mandate?.amount).toLocaleString()}</td>
                                        <td className="gray-td">{mandate?.accountNumber}</td>
                                        <td className="gray-td">{mandate?.bankName}</td>
                                        <td className="gray-td">{mandate?.narration}</td>

                                        <td className="gray-td">{mandate?.workFlowStatusDescription} ({mandate?.workFlowStatus})</td>
                                        <td className="gray-td">{moment(mandate?.createdAt).format('DD MMM, YYYY')}</td>
                                        <td style={{ textAlign: "center" }} >
                                            <div className="relative" style={{ position: "relative" }}>
                                                {/* Dropdown Toggle Button */}
                                                <button
                                                    onClick={() => toggleDropdown(mandate?.contractId, mandate?.id, mandate)}
                                                    className="dotsBtn"
                                                >
                                                    <HiOutlineDotsVertical />
                                                </button>

                                                {/* Dropdown Menu - Show only for the selected row */}
                                                {openDropdownId === mandate?.contractId && (
                                                    <div className="dropdownSelect" ref={dropdownRef} style={{ boxShadow: '0 0 10px rgba(0, 0, 0, 0.15)', zIndex: 100 }}>
                                                        <div className="updateBtn">
                                                            <button
                                                                onClick={() => {
                                                                    //   navigate(`/workflow-report/${mandate?.sessionId}`)
                                                                    setShowSingleDebitModal(true)
                                                                }}
                                                                style={{ border: "none", backgroundColor: "white", padding: "5px" }}
                                                            >
                                                                Single debit
                                                            </button>
                                                        </div>
                                                        <div className="updateBtn">
                                                            <button
                                                                onClick={async () => {
                                                                    await handleTransaction(mandate)
                                                                }}
                                                                style={{ border: "none", backgroundColor: "white", padding: "5px" }}
                                                            >
                                                                Transaction history
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                    <ReactPaginate
                        previousLabel={"Prev"}
                        nextLabel={"Next"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pageCount} // Total pages from API
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={currentPage - 1}
                    />
                    
                    <LoadingModal show={isLoading} />
                    <ModalSingleDebit 
                    show={showSingleDebitModal} 
                    toggle={() => setShowSingleDebitModal(!showSingleDebitModal)} 
                    handleUpdateResumptionDate={handleSingleDebit} 
                    isUpdating={loadDebitting} 
                    mandateInfo={mandateInfo}
                    resumption={resumption}
                    setIsResumption={setIsResumption}
                    note={note}
                    setNote={setNote} 
                    handleTransaction={handleTransaction}
                    />
                    <AllNewTransactionModal
                        state={stateTransact}
                        anchor={anchor}
                        toggleDrawer={toggleDrawerTransact}
                        subscriberCode={selectedDetails?.contractId}
                        history={history}
                    />
                    <AddDebitMandateModal
                    showFilter={showFilter}
                    toggleFilter={toggleFilter}
                    filterLoading={uploadingOnDemand}
                    onSubmit={handleSubmit}
                     />
                </div>
            )}
        </>
    )
}

export default AllNewMandates